import _ from 'lodash';
import uri from 'urijs';
/**
 * @constant
 * @type {Filters}
 */
const DEFAULT_FILTERS = {
    equipment: [],
    eventNames: [],
    dateRange: {
        start: '',
        end: ''
    },
};
export default class EventInfoService {
    eventsConfig;
    getDefaultFilters;
    $sails;
    $q;
    $log;
    constructor($sails, $q, $log, appConfig) {
        'ngInject';
        this.$sails = $sails;
        this.$q = $q;
        this.$log = $log;
        this.eventsConfig = appConfig.eventsConfig;
        this.getDefaultFilters = () => _.cloneDeep(DEFAULT_FILTERS);
    }
    getEvent(eventId) {
        return this.$sails.get(`/event/${eventId}`)
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        });
    }
    /**
     * @param {EventQuery} args
     * @param  {string|Array<string>} args.equipment id(s) of equipment
     * @param  {number} args.limit limit to number of events to return
     * @param  {number} args.skip results to skip for paginating
     * @param  {boolean} [args.flagged=false] only get events that have been flagged
     * @param  {Date|string|number} [args.startDate] events after
     * @param  {Date|string|number} [args.endDate] events before
     * @param  {Date} [args.filterDate] how far back to look for events, used for pagination
     * @param  {string|string[]} [args.eventNames]  event name(s) to filter by
     * @param  {object} [args.extraCriteria]  extraCriteria Other criteria filters
     * @param {number} [args.maxQueryDateRange=90] Max days to include
     * @returns {Promise<Array<object>>} Events
     */
    getEvents({ equipment, limit, skip, flagged, acknowledged, eventNames = [], 
    // TODO: Consolidate date objects
    startDate, endDate, filterDate, maxQueryDateRange, extraCriteria = {}, }) {
        // https://stackoverflow.com/questions/51596173
        const parseDate = (datelike) => _.isUndefined(datelike) ?
            null :
            new Date(datelike).valueOf();
        const query = uri(`/event/byequipment/${_.castArray(equipment).join('|')}`).query({
            limit,
            skip,
            flagged,
            acknowledged,
            eventNames: _.castArray(eventNames).join('|'),
            startDate: parseDate(startDate),
            endDate: parseDate(endDate),
            filterDate,
            maxQueryDateRange,
            ...extraCriteria,
        });
        return this.$sails
            .get(query.toString())
            .then(({ data: events }) => events)
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        });
    }
    /**
     * @param {EventQuery} args
     * @param  {string|Array<string>} args.equipment id(s) of equipment
     * @param  {number} args.limit limit to number of events to return
     * @param  {number} args.skip results to skip for paginating
     * @param  {boolean} [args.flagged=false] only get events that have been flagged
     * @param  {Date|string|number} [args.startDate] events after
     * @param  {Date|string|number} [args.endDate] events before
     * @param  {string|string[]} [args.eventNames]  event name(s) to filter by
     * @param  {object} [args.extraCriteria]  extraCriteria Other criteria filters
     * @param  {Array<Array<string,number>>} [args.sort]  sort Sort criteria [[field, 1|-1], [...]]
     * @returns {Promise<Array<object>>} Events
     */
    getEventsGrouped({ equipment, limit, skip, flagged = false, eventNames = [], 
    // TODO: Consolidate date objects
    startDate, endDate, extraCriteria = {}, sort = [] }) {
        // https://stackoverflow.com/questions/51596173
        const parseDate = (datelike) => _.isUndefined(datelike) ?
            null :
            new Date(datelike).valueOf();
        const query = uri(`/event/byequipment/${_.castArray(equipment).join('|')}/grouped`).query({
            limit,
            skip,
            flagged,
            eventNames: _.castArray(eventNames).join('|'),
            startDate: parseDate(startDate),
            endDate: parseDate(endDate),
            ...extraCriteria,
            sort: _.map(sort, ([field, direction]) => `${field}=${direction}`).join('|'),
        });
        return this.$sails
            .get(query.toString())
            .then(({ data: events }) => events)
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        });
    }
    updateEvent(eventId, updatedEventFields) {
        return this.$sails.put(`/event/${eventId}`, updatedEventFields)
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        });
    }
    deleteEvent(eventId) {
        return this.$sails.delete(`/event/${eventId}`)
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        });
    }
    dismissAllEventsByEquipment(equipmentId) {
        return this.$sails.put(`/event/dismissAllEventsByEquipment/${equipmentId}`)
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        });
    }
}
